function toBase64UrlPayload(token) {
  const raw = String(token || '').replace(/^Bearer\s+/i, '').trim()
  const parts = raw.split('.')
  return parts.length >= 2 ? parts[1] : ''
}

function decodeBase64Url(input) {
  const normalized = String(input || '').replace(/-/g, '+').replace(/_/g, '/')
  const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4)
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(padded, 'base64').toString('utf8')
  }
  return decodeURIComponent(
    Array.prototype.map.call(atob(padded), ch => {
      return '%' + ('00' + ch.charCodeAt(0).toString(16)).slice(-2)
    }).join(''),
  )
}

function decodeJwtPayload(token) {
  const payload = toBase64UrlPayload(token)
  if (!payload) return null
  try {
    return JSON.parse(decodeBase64Url(payload))
  } catch (error) {
    return null
  }
}

function getTeamUsernameSuffix(teamID) {
  const numericID = Number(teamID)
  if (!Number.isInteger(numericID) || numericID <= 0) {
    throw new Error('team_id is required')
  }
  return `@m${(numericID * 131 + 7919).toString(36)}`
}

function buildSubmittedUsername(username, suffix, includeSuffix) {
  const base = String(username || '').trim()
  if (!includeSuffix) return base
  return base.endsWith(suffix) ? base : `${base}${suffix}`
}

module.exports = {
  buildSubmittedUsername,
  decodeJwtPayload,
  getTeamUsernameSuffix,
}
